import { Navigate, Route, Routes } from "react-router-dom";
import PrivateRoutes from "../../core/routes/PrivateRoutes";
import { Operacao } from "../pages/Operacao";
import { OperacaoProvider } from "../contexts/OperacaoContext";
import { ConfiguracoesPedidoProvider } from "../contexts/ConfiguracoesPedidoContext";
import { HeaderContextProvider } from "../../core/contexts/HeaderContext";
import { Pedido } from "../pages/Pedido";
import { IEstabelecimento } from "../../estabelecimento/interfaces/IEstabelecimento";
import { EsteiraPedidos } from "../pages/EsteiraPedidos";
import { Layout } from "../../core/components/Layout";
import { ListagemPedidos } from "../pages/ListagemPedidos";
import { RelatorioAvaliacoes } from "../pages/RelatorioAvaliacoes";
import { OperacaoEdicao } from "../pages/OperacaoEdicao";
import { OperacaoEdicaoProvider } from "../contexts/OperacaoEdicaoContext";
import { ConversasAtendimento } from "../pages/atendimento/ConversasAtendimento";

interface IPedidosRoutesProps {
    autenticado: boolean;
}

export const PedidosRoutes = ({ autenticado }: IPedidosRoutesProps) => {
    return (
        <HeaderContextProvider>
            <ConfiguracoesPedidoProvider>
                <OperacaoProvider>
                    <OperacaoEdicaoProvider>
                        <Routes>
                            <Route element={
                                <Layout titulo="Pedidos">
                                    <PrivateRoutes
                                        autenticado={autenticado}
                                    />
                                </Layout>
                            }>
                                <Route path="/operacao" element={<Operacao />} />
                                <Route path="/conversas" element={<ConversasAtendimento />} />
                                <Route path="/:uuid" element={<Pedido />} />
                                <Route path="/operacao/edicao/:uuid" element={<OperacaoEdicao />} />
                                <Route path="/esteira" element={<EsteiraPedidos />} />
                                <Route path="/listagem" element={<ListagemPedidos />} />
                                <Route path="/avaliacoes" element={<RelatorioAvaliacoes />} />
                                <Route path="*" element={<Navigate to="/pagina-nao-encontrada" />} />
                            </Route>
                        </Routes>
                    </OperacaoEdicaoProvider>
                </OperacaoProvider>
            </ConfiguracoesPedidoProvider>
        </HeaderContextProvider >
    );
}